module.exports = __webpack_public_path__ + "img/language.bb596678.svg";